var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preview-mobile"},[_c('div',{staticClass:"mobile-head",class:_vm.client,style:({ backgroundColor: _vm.headBgColor })},[_c('div',{staticClass:"mobile-head-title"},[_vm._v(_vm._s(_vm.headTitle))])]),_c('div',{staticClass:"mobile-body",class:{ scroll: _vm.scroll }},[_vm._t("body")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }